export default "float quadraticOut(float t) {\n  return -t * (t - 2.0);\n}\n\n"